(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["sanislink-ceramic-acknowledgement"] && !Shopify.designMode) return;
  try {
    const sanislinkCeramicAckSelector = '[data-sanislink-ceramic-ack="required"]';
  const sanislinkCeramicAckCheckboxSelector = '.sanislink-ceramic-acknowledgement__checkbox';
  const sanislinkCeramicAckTimestampSelector = '[data-sanislink-ceramic-ack-timestamp]';
  const sanislinkCeramicAckPromptSelector = '[data-sanislink-ceramic-ack-prompt]';
  const sanislinkCeramicAckMessage = 'Please check the Ceramic acknowledgement before adding this product to cart.';

  document.addEventListener(
    'submit',
    (event) => {
      const form = event.target;

      if (!(form instanceof HTMLFormElement)) return;

      const acknowledgement = form.querySelector(sanislinkCeramicAckSelector);

      if (!acknowledgement) return;

      const checkbox = acknowledgement.querySelector(sanislinkCeramicAckCheckboxSelector);
      const timestamp = acknowledgement.querySelector(sanislinkCeramicAckTimestampSelector);
      const prompt = acknowledgement.querySelector(sanislinkCeramicAckPromptSelector);

      if (!checkbox || !checkbox.checked) {
        if (timestamp) timestamp.value = '';
        if (prompt) prompt.hidden = false;

        checkbox?.setCustomValidity(sanislinkCeramicAckMessage);
        checkbox?.reportValidity();
        checkbox?.focus();

        event.preventDefault();
        event.stopImmediatePropagation();
        return;
      }

      checkbox.setCustomValidity('');
      if (timestamp) timestamp.value = new Date().toISOString();
      if (prompt) prompt.hidden = true;
    },
    true
  );

  document.addEventListener('change', (event) => {
    const checkbox = event.target;

    if (!(checkbox instanceof HTMLInputElement)) return;
    if (!checkbox.matches(sanislinkCeramicAckCheckboxSelector)) return;

    const acknowledgement = checkbox.closest(sanislinkCeramicAckSelector);
    const timestamp = acknowledgement?.querySelector(sanislinkCeramicAckTimestampSelector);
    const prompt = acknowledgement?.querySelector(sanislinkCeramicAckPromptSelector);

    if (checkbox.checked) {
      checkbox.setCustomValidity('');
      if (timestamp) timestamp.value = new Date().toISOString();
      if (prompt) prompt.hidden = true;
    } else {
      if (timestamp) timestamp.value = '';
    }
  });
  } catch(e) { console.error(e); }
})();

})();
